import Vue from 'vue'
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyAL2JUloSw-XtUviH6T7V7ztfmX0d3g3T4",
        libraries: "places" // necessary for places input
    }
});